// extracted by mini-css-extract-plugin
export default {"item":"_3SPlQx3W","inactive":"_1i5wXJIA","icon":"_30CVIodB"};